import React from 'react';

const Footer = () => {
    return (
        <div className="mt-12">
            <p className="dark:text-gray-200 text-gray-700 text-center m-12">
                © 2023 All Rights Reserved By Dashify
            </p>
        </div>
    );
};

export default Footer;
